import { InjectionToken } from '@angular/core';

export const CONSTANTS_TOKEN = new InjectionToken<any>('constants');
